
export const schoolPrices = {
  monthlyFees: {
    // 05/07/2026: precios de familias nuevas igualados a los de las familias
    // actuales (tarifa de renovación): decisión de Pablo, campaña "Vecinos".
    infantil: {
      price: "450€",
      ageRange: "3-5",
      schedule: "9:00h a 14:00h",
      discounted: {
        second: "360€",  // -20%
        third: "270€"    // -40%
      }
    },
    primaryC1: {
      price: "520€",
      ageRange: "6-8",
      schedule: "9:00h a 14:00h",
      discounted: {
        second: "416€",  // -20%
        third: "312€"    // -40%
      }
    },
    primaryC2: {
      price: "550€",
      ageRange: "9-11",
      schedule: "9:00h a 14:00h",
      discounted: {
        second: "440€",  // -20%
        third: "330€"    // -40%
      }
    }
  },
  enrollment: {
    renewal: "350€",
    newStudents: {
      firstChild: "700€",
      siblings: "350€"
    }
  },
  specialDiscounts: {
    earlyEnrollment: {
      amount: "50€",
      deadline: "23 de Febrero"
    },
    annualPayment: {
      discount: "200€",
      voucher: "200€"
    }
  },
  additionalServices: {
    transport: {
      roundTrip: "225€/mes",
      note: "Ruta desde Vigo - mínimo 4 plazas - compromiso trimestral"
    },
    earlyBirds: {
      monthly: "75€",
      daily: "7€",
      schedule: "Desde las 8:15h",
      note: "Precio por familia"
    },
    food: {
      monthly: "195€",
      threeDays: "125€",
      twoDays: "90€",
      daily: "15€",
      description: "Comida y snack con productos ecológicos y locales",
      takeaway: "Comida para llevar disponible 14:00h-17:00h"
    },
    ludoteca: {
      schedule: "15:00h a 17:00h (viernes hasta las 16:00h)",
      freeWith: "Gratis con comedor o extraescolares",
      dayPass: "8€",
      oneDay: "25€",
      twoDays: "40€",
      fiveDays: "100€",
      note: "Precio por familia"
    }
  }
};
